module.exports = __webpack_public_path__ + "static/img/图片10.47276ff6.png";